import React from 'react';
import Layout from '../components/common/Layout';

const Contact = () => {
  return (
    <Layout title="Contacto" showBackButton={true}>
      <div className="flex flex-col items-center pt-8 pb-12">
        <div className="w-full max-w-md card">
          <h1 className="text-3xl font-bold mb-4 text-sangre-600 text-center">Contacto</h1>
          <p className="mb-4 text-gray-600 text-base text-justify">
            Si tienes dudas, sugerencias o necesitas soporte, puedes contactarnos a través de los siguientes medios:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-600 text-base">
            <li>Email: <a href="mailto:soporte@sangrefuerte.com" className="text-sangre-600 underline">soporte@sangrefuerte.com</a></li>
            <li>Formulario de contacto: próximamente disponible en la app</li>
          </ul>
          <p className="text-gray-600 text-base text-justify">
            Nuestro equipo responderá lo antes posible para ayudarte con cualquier inconveniente o consulta relacionada con la aplicación.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Contact; 